import { clientApi } from 'api';
import { IFilter } from 'server/models/Filter/types';
export const getProductfilterById = (isServer = false) => async (id: string) => {
  const response = await clientApi.get<IFilter>(`/filter-products/${id}`);

  return response;
};
